import React from 'react';

import { TouchableOpacity, View } from 'react-native';

import { useTranslation } from 'react-i18next';

import { RoundedArrow } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import { TIMELINE_NOW_ID } from 'config/testID';

import { COLOR } from 'utils/colors';

import { ArrowDirection } from 'screens/Epg/utils/epg-config';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import styles from './styles';

type Props = {
    onPressMarker?: () => void;
    direction?: ArrowDirection;
};

const {
    ACCESSIBILITY: {
        EPG: { ACCESSIBILITY_EPG_NOW_INDICATOR },
    },
} = LANGUAGE_KEYS;

const EpgNowJumpMarker = ({
    onPressMarker,
    direction = ArrowDirection.LEFT,
}: Props) => {
    const { t } = useTranslation();

    return (
        <TouchableOpacity
            accessible
            accessibilityLabel={t(ACCESSIBILITY_EPG_NOW_INDICATOR)}
            accessibilityRole="button"
            style={[
                direction === ArrowDirection.LEFT
                    ? styles.leftContainer
                    : styles.container,
            ]}
            onPress={onPressMarker}
            testID={TIMELINE_NOW_ID}
        >
            <View
                style={{
                    transform: [
                        { scaleX: direction === ArrowDirection.LEFT ? 1 : -1 },
                        {
                            translateX: 1,
                        },
                    ],
                }}
            >
                <RoundedArrow height={24} fill={COLOR.JUMP_MARKER_RED} />
            </View>
            <View
                style={[
                    styles.textContainer,
                    direction === ArrowDirection.RIGHT
                        ? styles.rightTextContainer
                        : styles.leftTextContainer,
                ]}
            >
                <Text
                    category={ETextCategory.caption1}
                    color={ETextColor.neutral}
                    style={styles.text}
                    bold
                >
                    {t('DAY_NAME_TODAY_NOW').toUpperCase()}
                </Text>
            </View>
        </TouchableOpacity>
    );
};

export default EpgNowJumpMarker;
